var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.30371,
    y: 3.40625,
    width: 47.3962,
    height: 47.3962,
    rx: 23.6981,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8888 30.0639V31.2488C35.8888 32.9078 35.8888 33.7373 35.566 34.371C35.2819 34.9284 34.8288 35.3816 34.2714 35.6656C33.6377 35.9884 32.8082 35.9884 31.1492 35.9884H22.8549C21.1958 35.9884 20.3663 35.9884 19.7327 35.6656C19.1753 35.3816 18.7221 34.9284 18.4381 34.371C18.1152 33.7373 18.1152 32.9078 18.1152 31.2488V30.0639M31.9391 23.152L27.002 18.2148M27.002 18.2148L22.0649 23.152M27.002 18.2148V30.0639",
    stroke: "#475467",
    strokeWidth: 1.97484,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.30371,
    y: 3.40625,
    width: 47.3962,
    height: 47.3962,
    rx: 23.6981,
    stroke: "#F9FAFB",
    strokeWidth: 5.92453
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.27f64b04d6c8fa2508d48b8f0caf2ec8.svg";
export { ForwardRef as ReactComponent };